import * as adminApi from '@/api/admin'

const state = {
  dashboard: null,
  users: [],
  usersTotal: 0,
  plans: [],
  subscriptions: [],
  subscriptionsTotal: 0,
  canvaImportReports: [],
  canvaImportReportsTotal: 0,
  loading: false,
}

const getters = {
  dashboard: (s) => s.dashboard,
  users: (s) => s.users,
  usersTotal: (s) => s.usersTotal,
  plans: (s) => s.plans,
  subscriptions: (s) => s.subscriptions,
  subscriptionsTotal: (s) => s.subscriptionsTotal,
  canvaImportReports: (s) => s.canvaImportReports,
  canvaImportReportsTotal: (s) => s.canvaImportReportsTotal,
  loading: (s) => s.loading,
}

const actions = {
  async fetchDashboard({ commit }) {
    commit('SET_LOADING', true)
    try {
      const { data } = await adminApi.getDashboard()
      commit('SET_DASHBOARD', data.data)
      return data.data
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchUsers({ commit }, params = {}) {
    commit('SET_LOADING', true)
    try {
      const { data } = await adminApi.listUsers(params)
      commit('SET_USERS', { users: data.data.users || [], total: data.data.total || 0 })
      return data.data
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchUser(_, id) {
    const { data } = await adminApi.getUser(id)
    return data.data.user
  },

  async updateUser(_, { id, payload }) {
    const { data } = await adminApi.updateUser(id, payload)
    return data.data
  },

  async resetUserApiKey(_, id) {
    const { data } = await adminApi.resetUserApiKey(id)
    return data.data
  },

  async fetchPlans({ commit }) {
    commit('SET_LOADING', true)
    try {
      const { data } = await adminApi.listPlans()
      commit('SET_PLANS', data.data.plans || [])
      return data.data.plans
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async createPlan(_, payload) {
    const { data } = await adminApi.createPlan(payload)
    return data.data
  },

  async updatePlan(_, { id, payload }) {
    const { data } = await adminApi.updatePlan(id, payload)
    return data.data
  },

  async deactivatePlan(_, id) {
    await adminApi.deactivatePlan(id)
  },

  async fetchSubscriptions({ commit }, params = {}) {
    commit('SET_LOADING', true)
    try {
      const { data } = await adminApi.listSubscriptions(params)
      commit('SET_SUBSCRIPTIONS', {
        subscriptions: data.data.subscriptions || [],
        total: data.data.total || 0,
      })
      return data.data
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async cancelSubscription(_, id) {
    await adminApi.cancelSubscription(id)
  },

  async fetchCanvaImportReports({ commit }, params = {}) {
    commit('SET_LOADING', true)
    try {
      const { data } = await adminApi.listCanvaImportReports(params)
      commit('SET_CANVA_IMPORT_REPORTS', {
        reports: data.data.reports || [],
        total: data.data.total || 0,
      })
      return data.data
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async updateCanvaImportReport({ dispatch }, { id, payload, listParams }) {
    await adminApi.updateCanvaImportReport(id, payload)
    if (listParams) await dispatch('fetchCanvaImportReports', listParams)
  },
}

const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_DASHBOARD(state, dashboard) {
    state.dashboard = dashboard
  },
  SET_USERS(state, { users, total }) {
    state.users = users
    state.usersTotal = total
  },
  SET_PLANS(state, plans) {
    state.plans = plans
  },
  SET_SUBSCRIPTIONS(state, { subscriptions, total }) {
    state.subscriptions = subscriptions
    state.subscriptionsTotal = total
  },
  SET_CANVA_IMPORT_REPORTS(state, { reports, total }) {
    state.canvaImportReports = reports
    state.canvaImportReportsTotal = total
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
